export function buildImageUrl(
  baseUrl: string,
  width?: number,
  height?: number,
): string {
  if (!width && !height) {
    return baseUrl;
  }
  let url: URL;
  try {
    url = new URL(baseUrl);
  } catch {
    return baseUrl;
  }
  if (width) {
    url.searchParams.set("width", String(width * 4));
  }
  if (height) {
    url.searchParams.set("height", String(height * 4));
  }
  return url.toString();
}
